/**
 * Tenant 로그인 라우트 (/login)
 * @description 이미 Tenant 인증되어 있으면 /entry로 리다이렉트
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { config } from '@shared/config';
import { getQueryParam } from '@shared/router';
import { getTenantAuthStorage } from '@/utils/authStorage';
import { TenantLoginPage } from '@/features/auth/pages/TenantLoginPage';

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    const storage = getTenantAuthStorage();
    const storedUser = storage.getUser();
    const storedToken = storage.getToken();

    if (!storedUser || !storedToken) return;

    try {
      if (storedUser.userType !== 'tenant-user') {
        storage.clear();
        return;
      }
      const response = await fetch(`${config.apiUrl}/api/portal/auth/me`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'X-Tenant-Id': storedUser.tenantId,
        },
      }).catch(() => null);

      if (!response) return; // 네트워크 오류: 저장소 유지, 로그인 화면 그대로
      if (response.status === 401) {
        storage.clear();
        return;
      }
      if (response.ok) {
        const returnUrl = getQueryParam('returnUrl');
        if (returnUrl) {
          const target = decodeURIComponent(returnUrl);
          if (target.startsWith('/')) {
            throw redirect({ href: target });
          }
        }
        throw redirect({ to: '/entry' });
      }
      // 5xx 등: 저장소 유지
    } catch (error) {
      if (error && typeof error === 'object' && 'to' in error) throw error;
    }
  },
  component: TenantLoginPage,
});
